// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"2681":"users","3289":"medicineMedicine","3765":"adverse-reaction","4425":"adverse-reaction.id"}[chunkId] + "." + {"2681":"e3199021","3289":"4c152ffd","3765":"27d307fc","4425":"85ef6dc2"}[chunkId] + ".css";
};